import { datadogRum } from '@datadog/browser-rum';

import { User, getAuthenticatedUser } from '../AuthenticationService';
import { Configuration, getConfig } from '../ConfigurationService';
import ConsentService, { ConsentCategory } from '../ConsentService';
import { FeatureFlag, get as getFeatureFlag } from '../FeatureFlagService';

export const enableMonitoring = (sampleRate = 100) => {
  if (datadogRum.getInitConfiguration()) {
    return datadogRum;
  }

  datadogRum.init({
    applicationId: environment.DATADOG_RUM_APPLICATION_ID,
    clientToken: environment.DATADOG_RUM_CLIENT_TOKEN,
    site: environment.DATADOG_SITE,
    service: environment.DATADOG_SERVICE,
    env: environment.DATADOG_ENVIRONMENT,
    version: environment.BUILD_IDENTIFIER,
    sessionSampleRate: sampleRate,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: environment.DATADOG_RUM_TRACE_ORIGINS,
    sessionReplaySampleRate: 100,
    startSessionReplayRecordingManually: true,
  });

  // It's recommended to set at least one user attribute
  // https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#identify-user-sessions
  datadogRum.setUser({
    id: getAuthenticatedUser(User.Uuid),
  });
  datadogRum.setGlobalContextProperty('account_id', getAuthenticatedUser(User.AccountId));
  datadogRum.setGlobalContextProperty('user_id', getAuthenticatedUser(User.EmployeeId));

  return datadogRum;
};

export const initialize = () => {
  if (!environment.DATADOG_RUM_ENABLED || !ConsentService.isCategoryConsented(ConsentCategory.Necessary)) {
    return;
  }

  const sampleRate = getConfig(Configuration.DebugRecordSessionEnabled)
    ? 100
    : (getFeatureFlag(FeatureFlag.RealUserMonitoringSampleRate, 0) as number);

  if (sampleRate === 0) {
    return;
  }

  enableMonitoring(sampleRate);
};
